export interface SavedProject {
  id: string;
  name: string;
  type: 'design' | 'inspect';
  roomTypeId: string;
  roomTypeNameAr: string;
  area: number;
  targetLux: number;
  fixtureCount: number;
  totalWatts: number;
  estimatedLux?: number;
  currentLux?: number;
  status: 'good' | 'warning' | 'poor' | 'excess';
  createdAt: string;
  data: Record<string, unknown>;
}

const STORAGE_KEY = 'almuhandis_projects';

export function getProjects(): SavedProject[] {
  if (typeof window === 'undefined') return [];
  try {
    const raw = localStorage.getItem(STORAGE_KEY);
    return raw ? JSON.parse(raw) : [];
  } catch {
    return [];
  }
}

export function saveProject(project: Omit<SavedProject, 'id' | 'createdAt'>): SavedProject {
  const projects = getProjects();
  const newProject: SavedProject = {
    ...project,
    id: `proj-${Date.now()}`,
    createdAt: new Date().toISOString(),
  };
  projects.unshift(newProject);
  // Backend integration point: POST /api/projects
  localStorage.setItem(STORAGE_KEY, JSON.stringify(projects));
  return newProject;
}

export function updateProject(id: string, updates: Partial<SavedProject>): void {
  const projects = getProjects();
  const idx = projects.findIndex((p) => p.id === id);
  if (idx !== -1) {
    projects[idx] = { ...projects[idx], ...updates };
    // Backend integration point: PUT /api/projects/:id
    localStorage.setItem(STORAGE_KEY, JSON.stringify(projects));
  }
}

export function deleteProject(id: string): void {
  const projects = getProjects().filter((p) => p.id !== id);
  // Backend integration point: DELETE /api/projects/:id
  localStorage.setItem(STORAGE_KEY, JSON.stringify(projects));
}

export function duplicateProject(id: string): SavedProject | null {
  const projects = getProjects();
  const original = projects.find((p) => p.id === id);
  if (!original) return null;
  return saveProject({ ...original, name: `${original.name} (نسخة)` });
}